<template>
  <select
    v-model="selectedValue"
    @change="$emit('input', selectedValue)"
    class="form-control form-control-sm"
    style="border: 0px; width: auto; font-size: x-large;">
    <option :value="0">🏁 たった今</option>
    <option :value="30">🕧 30分前</option>
    <option :value="1 * 60">🕐 1時間前</option>
    <option :value="3 * 60">🕒 3時間前</option>
    <option :value="8 * 60">🕗 8時間前</option>
  </select>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return { selectedValue: 0 }
  },
  mounted() {
    this.selectedValue = this.value
  },
  watch: {
    value(newValue, oldValue) {
      this.selectedValue = newValue
    }
  }
}
</script>

<style scoped>
</style>
